// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewcontrolRoutineRunId } from './BrewcontrolRoutineRun';
import { equipmentId } from './Equipment';
import { fermentorModelCalibrationTargetId } from './FermentorModelCalibrationTarget';
import { fermentationId } from './Fermentation';
import { fermentationGroupTaskId } from './FermentationGroupTask';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationCalibrationLaunch = z.object({
    routine_run_id: brewcontrolRoutineRunId,
    equipment_id: equipmentId,
    target_id: fermentorModelCalibrationTargetId,
    fermentation_id: fermentationId.nullable(),
    fermentation_group_task_id: fermentationGroupTaskId.nullable(),
    launched_by: operatorId.nullable(),
    created_at: z.date(),
});
export const fermentationCalibrationLaunchInitializer = z.object({
    routine_run_id: brewcontrolRoutineRunId,
    equipment_id: equipmentId,
    target_id: fermentorModelCalibrationTargetId,
    fermentation_id: fermentationId.optional().nullable(),
    fermentation_group_task_id: fermentationGroupTaskId.optional().nullable(),
    launched_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
});
export const fermentationCalibrationLaunchMutator = z.object({
    routine_run_id: brewcontrolRoutineRunId.optional(),
    equipment_id: equipmentId.optional(),
    target_id: fermentorModelCalibrationTargetId.optional(),
    fermentation_id: fermentationId.optional().nullable(),
    fermentation_group_task_id: fermentationGroupTaskId.optional().nullable(),
    launched_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=FermentationCalibrationLaunch.js.map